'use strict';

import FailIcon from '@material-ui/icons/Close';
import bemit from 'Functions/bemit';
import Link from 'Pure/Link';
import { URL } from 'Shared/Routes';
export default function PaymentFailure(props) {
  const output = /*#__PURE__*/React.createElement("div", {
    className: bemit('c-payment-form', ['failure'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-payment-form__content"
  }, /*#__PURE__*/React.createElement(FailIcon, {
    className: "c-payment-form__failure-icon"
  }), props.children, /*#__PURE__*/React.createElement(Link, {
    href: URL('FrontBookingPage'),
    className: bemit('c-flat-btn', ['front', 'payment-back-home'])
  }, /*#__PURE__*/React.createElement("strong", null, '<'), "\xA0Retourner au paiement")));
  return output;
}
